<template>
  <div>
    <ToolbarAuth />
    <div v-if="saving">
      <saving />
    </div>
    <div class="mt-15 ml-15 mr-15">
      <v-card class="mb-15">
        <v-row no-gutters>
          <v-col cols="12">
            <h3 class="primary--text ma-8">Personalia (bewerk noodplan BV)</h3>
          </v-col>
        </v-row>
        <ValidationObserver ref="obs" v-slot="{ invalid, validated, handleSubmit, errors }">
          <v-form ref="form">
            <v-row class="ml-8 mr-8" no-gutters>
              <v-col cols="6" class="mr-4">
                <ValidationProvider v-bind:name="$t('users.gender')" rules="required" v-slot="{ errors, valid }">
                  <v-select
                    required
                    cache-items
                    :items="$t('gender.items')"
                    item-text="label"
                    item-value="value"
                    v-bind:label="$t('users.gender')"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    v-model="gender_client"
                    :menu-props="{ offsetY: true }"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col>
                <BaseValInput rules="required|max:50" v-model="first_name_client" v-bind:label="$t('users.first_name')" />
              </v-col>
              <v-col cols="12">
                <BaseValInput rules="required|max:150" v-model="last_name_client" v-bind:label="$t('users.last_name')" />
              </v-col>
              <v-col cols="12">
                <BaseValInput rules="required|max:150" v-model="address_client" label="Adres" />
              </v-col>
              <v-col cols="6" class="mr-4">
                <BaseValInput rules="required|max:150" v-model="zip_client" label="Postcode" />
              </v-col>
              <v-col>
                <BaseValInput rules="required|max:150" v-model="place_client" label="Plaats" />
              </v-col>
              <v-col cols="6" class="mr-4"><BaseValInput rules="required|max:15" v-model="phone_number_client" label="Telefoon" /></v-col>
              <v-col><BaseValInput rules="required|email" v-model.trim="email_client" label="e-mail" @keyup="lowercase" /></v-col>
              <v-col cols="12">
                <ValidationProvider v-bind:name="$t('users.RelMan')" rules="required" v-slot="{ errors, valid }">
                  <v-select
                    required
                    cache-items
                    :items="users"
                    item-text="first_last"
                    item-value="id"
                    label="Relatiemanager"
                    outlined
                    v-model="user_id"
                    :menu-props="{ offsetY: true }"
                    :error-messages="errors"
                    :success="valid"
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col>
                <BaseValInput rules="required|max:150" v-model="rel_number" label="Relatienummer" />
              </v-col>
            </v-row>
            <v-divider />
            <v-divider />
            <v-row no-gutters>
              <v-col cols="12">
                <h3 class="primary--text ma-8">Onderneming</h3>
              </v-col>
            </v-row>
            <v-row class="ml-8 mr-8" no-gutters>
              <v-col cols="12">
                <BaseValInput rules="required|max:150" v-model="name_company" label="Naam onderneming" />
              </v-col>
              <v-col cols="12">
                <BaseValInput rules="required|max:150" v-model="address_company" label="Adres onderneming" />
              </v-col>
              <v-col cols="6" class="mr-4">
                <BaseValInput rules="required|max:150" v-model="zip_company" label="Postcode" />
              </v-col>
              <v-col>
                <BaseValInput rules="required|max:150" v-model="place_company" label="Vestigingsplaats" />
              </v-col>
              <v-col cols="12"> Wordt het belang in deze BV aangehouden via een personal holding? </v-col>
              <v-col cols="12">
                <base-radio v-model="question_a" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              </v-col>
              <v-col cols="12" v-if="question_a === 'ke1'">Wat is de positie van de personal holding in deze BV?</v-col>
              <base-radio
                v-if="question_a === 'ke1'"
                v-model="question_b"
                :error-messages="errors"
                rules="required"
                nrOptions="3"
                optionA="Enig aandeel- of certificaathouder (100%)"
                optionB="Meerderheidsaandeel- of certificaathouder (50% of meer)"
                optionC="Minderheidsaandeel- of certificaathouder (minder dan 50%)"
              />
              <v-col cols="12" v-if="question_a === 'ke2'"> Wordt het belang in deze BV aangehouden via een tussen-holding? </v-col>
              <v-col cols="12">
                <base-radio v-if="question_a === 'ke2'" v-model="question_c" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              </v-col>
              <v-col cols="12" v-if="question_c === 'ke1' && question_a === 'ke2'">Wat is de positie van de tussen holding in deze BV?</v-col>
              <base-radio
                v-if="question_c === 'ke1' && question_a === 'ke2'"
                v-model="question_d"
                :error-messages="errors"
                rules="required"
                nrOptions="3"
                optionA="Enig aandeel- of certificaathouder (100%)"
                optionB="Meerderheidsaandeel- of certificaathouder (50% of meer)"
                optionC="Minderheidsaandeel- of certificaathouder (minder dan 50%)"
              />
              <v-col cols="12">Is er sprake van mede-eigenaren? ( bij nee, wordt de module mede-eigenaren niet aangeboden)</v-col>
              <base-radio v-model="question_h" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />

              <v-col cols="12" v-if="question_h === 'ke1'">Is er sprake van aanbiedingsplicht? ( bij ja worden de modules m.b.t eigendomsstrategie niet aangeboden)</v-col>
              <base-radio v-if="question_h === 'ke1'" v-model="question_f" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />

              <v-col cols="12">Wilt u de detailgegevens van onderliggende BV’s (werkmaatschappijen en deelnemingen) door de klant laten invullen of vult u deze zelf in?</v-col>
              <v-col cols="12" class="info--text"
                >Als sprake is van een complexe situatie met meer dan 5 BV’s, kunt u het beste zelf deze detailgegevens invullen. Hiervoor gaat u naar de module Structuur. Hier kunt u deze
                detailgegevens invullen of ervoor kiezen om in het eindrapport een organogram met een beschrijving op te nemen.</v-col
              >
              <base-radio v-model="question_i" :error-messages="errors" rules="required" nrOptions="2" optionA="De klant vult de detailgegevens in" optionB="Ik vul zelf de detailgegevens in" />
            </v-row>

            <v-divider />
            <v-row no-gutters>
              <v-col cols="12">
                <h3 class="primary--text ma-8">App</h3>
              </v-col>
            </v-row>
            <v-row class="ml-8 mr-8" no-gutters>
              <v-col cols="12">Wilt u de klant de mogelijkheid geven om gebruik te maken van de app? </v-col>
              <v-col cols="12">
                <base-radio v-model="useApp" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              </v-col>
            </v-row>
            <v-row class="ml-8 mr-8" no-gutters v-if="useApp === 'ke1'">
              <v-col cols="12">Dient de klant periodiek een reminder te krijgen om gegevens te actualiseren?</v-col>
              <base-radio v-model="yearly_reminder" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              <v-col cols="12">Wilt u dat de klant een mail krijgt na afronding van een module?</v-col>
              <base-radio v-model="question_g" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              <v-col cols="12">Welke stijl wilt u hanteren voor deze klant?</v-col>
              <base-radio v-model="style" :error-messages="errors" rules="required" nrOptions="2" optionA="Formeel" optionB="Informeel" />
              <v-col cols="12">Wilt u een persoonlijke tekst toevoegen aan de standaard e-mailuitnodiging?</v-col>
              <base-radio v-model="personalNote" :error-messages="errors" rules="required" nrOptions="2" optionA="Ja" optionB="Nee" />
              <v-col cols="12">
                <base-val-area v-if="personalNote === 'ke1'" rules="required" v-model="personalNoteText" label="Uw tekst" />
              </v-col>
            </v-row>
            <v-divider />

            <v-col cols="12"> </v-col>
            <div class="text-end mr-15 mt-8 mb-15">
              <v-btn class="mr-5" color="secondary" @click="closeItem">{{ $t("crud.close") }}</v-btn>
              <v-btn color="primary" @click="handleSubmit(saveItem)" :disabled="invalid">{{ $t("crud.change") }}</v-btn>
            </div>
          </v-form>
        </ValidationObserver>
        <FlashMessage :error="error" v-if="error" key="error" />
        <v-row></v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import saving from "@/components/saving";
import nplanBvService from "@/services/nplan/NplanBvService";
export default {
  name: "Users",
  components: {
    FlashMessage,
    ToolbarAuth,
    saving,
  },
  data() {
    return {
      saving: false,
      user_id: null,
      gender_client: "",
      first_name_client: "",
      last_name_client: "",
      address_client: "",
      zip_client: "",
      place_client: "",
      phone_number_client: "",
      email_client: "",
      name_company: "",
      address_company: "",
      zip_company: "",
      place_company: "",
      rel_number: "",
      yearly_reminder: "",
      style: "",
      personalNote: "",
      personalNoteText: "",
      useApp: "",
      question_a: "",
      question_b: "",
      question_c: "",
      question_d: "",
      question_e: "",
      question_f: "",
      question_g: "",
      question_h: "",
      question_i: "",
      useModB: true,
      useModC: true,
      useModD: true,
      useModE: true,
      useModG: true,
      useModF: true,
    };
  },
  methods: {
    lowercase() {
      this.email_client = this.email_client.toLowerCase();
    },
    saveItem() {
      if (this.question_f === "ke1") {
        this.useModB = false;
        this.useModC = false;
        this.useModD = false;
        this.useModE = false;
      } else {
        this.useModB = true;
        this.useModC = true;
        this.useModD = true;
        this.useModE = true;
      }
      if (this.question_h === "ke1") {
        this.useModG = true;
      }
      if (this.question_h === "ke2") {
        this.useModG = false;
      }
      if (this.question_i === "ke1") {
        this.useModF = true;
      }
      if (this.question_i === "ke2") {
        this.useModF = false;
      }

      this.saving = true;
      let clientId = this.$route.params.id;
      const payload = {
        user_id: this.user_id,
        gender_client: this.gender_client,
        first_name_client: this.first_name_client,
        last_name_client: this.last_name_client,
        address_client: this.address_client,
        zip_client: this.zip_client,
        place_client: this.place_client,
        phone_number: this.phone_number,
        email_client: this.email_client,
        phone_number_client: this.phone_number_client,
        rel_number: this.rel_number,
        name_company: this.name_company,
        address_company: this.address_company,
        zip_company: this.zip_company,
        place_company: this.place_company,
        question_a: this.question_a,
        question_b: this.question_b,
        question_c: this.question_c,
        question_d: this.question_d,
        question_e: this.question_e,
        question_f: this.question_f,
        question_g: this.question_g,
        question_h: this.question_h,
        question_i: this.question_i,
        useModB: this.useModB,
        useModC: this.useModC,
        useModD: this.useModD,
        useModE: this.useModE,
        useModG: this.useModG,
        useModF: this.useModF,
        useApp: this.useApp,
        personalNote: this.personalNote,
        personalNoteText: this.personalNoteText,
        style: this.style,
        yearly_reminder: this.yearly_reminder,
      };
      this.error = null;
      nplanBvService
        .updateMain(clientId, payload)
        .then(() => {
          this.saving = false;
          this.$router.replace({ name: "bvIndex" });
        })
        .catch((error) => {
          this.saving = false;
          this.error = getError(error);
        });
    },

    closeItem() {
      this.$router.replace({ name: "bvIndex" });
    },
  },
  computed: {
    ...mapGetters("user", ["users"]),
    ...mapGetters("bvSingle", ["loading", "error", "bv_planSingle"]),
  },
  created() {
    let ClientId = this.$route.params.id;
    this.$store.dispatch("bvSingle/getBVplan", ClientId);
    this.$store.dispatch("user/getUsers");
  },
  mounted() {
    this.user_id = this.bv_planSingle.user_id;
    this.first_name_client = this.bv_planSingle.first_name_client;
    this.last_name_client = this.bv_planSingle.last_name_client;
    this.address_client = this.bv_planSingle.address_client;
    this.zip_client = this.bv_planSingle.zip_client;
    this.place_client = this.bv_planSingle.place_client;
    this.gender_client = this.bv_planSingle.gender_client;
    this.phone_number_client = this.bv_planSingle.phone_number_client;
    this.email_client = this.bv_planSingle.email_client;
    this.rel_number = this.bv_planSingle.rel_number;
    this.name_company = this.bv_planSingle.name_company;
    this.address_company = this.bv_planSingle.address_company;
    this.zip_company = this.bv_planSingle.zip_company;
    this.place_company = this.bv_planSingle.place_company;
    this.question_a = this.bv_planSingle.question_a;
    this.question_b = this.bv_planSingle.question_b;
    this.question_c = this.bv_planSingle.question_c;
    this.question_d = this.bv_planSingle.question_d;
    this.question_e = this.bv_planSingle.question_e;
    this.question_f = this.bv_planSingle.question_f;
    this.question_g = this.bv_planSingle.question_g;
    this.question_h = this.bv_planSingle.question_h;
    this.question_i = this.bv_planSingle.question_i;
    this.personalNote = this.bv_planSingle.personalNote;
    this.style = this.bv_planSingle.style;
    this.yearly_reminder = this.bv_planSingle.yearly_reminder;
    this.useApp = this.bv_planSingle.useApp;
    this.personalNoteText = this.bv_planSingle.personalNoteText;
  },
};
</script>

<style scoped></style>
